/* eslint-disable no-param-reassign */
const state = {
  orders: [],
  active: false, // Indicate shopping list page is active or not
};

const mutations = {
  setOrders(stateIn, ordersIn) {
    stateIn.orders = [];
    if (ordersIn != null) {
      stateIn.orders = [...ordersIn];
    }
  },
  setActive(stateIn, activeIn) {
    stateIn.active = activeIn;
  },
};

const getters = {
  orders(stateIn) {
    return stateIn.orders;
  },
  active(stateIn) {
    return stateIn.active;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
